<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container fluid>
            <v-card>
                <v-card-text>
                    <h1>General Ledger Status</h1>
                    <v-layout>
                        <v-flex xs2>
                            <v-menu v-model="menuMonth" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                                offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="searchMonth" label="Select Month:" prepend-icon="event" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="searchMonth" @input="menuMonth = false" :max="nowDate" type="month" @change="changeMonth()"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex>
                            <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                    <v-btn @click="searchYear" v-on="on"><v-icon>date_range</v-icon>year</v-btn>
                                </template>
                                <span>Search general ledger by last year</span>
                            </v-tooltip>
                        </v-flex>
                    </v-layout>

                    <div>
                        <!-- General Ledger Status -->
                        <v-data-table :headers="headers" :items="detail" class="elevation-1" v-bind:pagination.sync="pagination">
                            <template v-slot:no-data>
                                <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                            </template>
                            <template v-slot:items="props">
                                <td>{{props.item.glDate.substr(0,10)}}</td>
                                <td>{{props.item.glNo}}</td>
                                <td>{{props.item.refNo.toString()}}</td>
                                <td>{{props.item.desc}}</td>
                                <td class="text-xs-left">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small class="mr-2" v-on="on" @click="viewGl(props.item)">visibility</v-icon>
                                        </template>
                                        <span>View general ledger details</span>
                                    </v-tooltip>
                                </td>
                            </template>
                        </v-data-table>

                        <!-- General Ledger View -->
                        <v-dialog v-model="showViewGl" max-width="1220px">
                            <v-card>
                                <v-card-title class="headline">
                                    <v-flex>
                                        General Ledger View
                                    </v-flex>
                                    <v-flex text-xs-right>
                                        <v-icon @click="showViewGl = false">clear</v-icon>
                                    </v-flex>
                                </v-card-title>
                                <v-card-text>
                                    dsafj
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
    </v-app>
</template>
<script>
import {db} from '@/firebase'
// import VueNumeric from 'vue-numeric'
import mainMenu from '@/components/mainMenu.vue'
export default {
    components: {
        // VueNumeric,
        mainMenu
    },
    data(){
        return{
            nowDate: new Date().toISOString().slice(0,10),
            menuMonth: false,
            searchMonth: new Date().toISOString().substr(0, 7),
            detail: [],

            headers:[
                { text: 'General ledger date', align: 'left', value: 'glDate' },
                { text: 'General ledger no', sortable: false, align: 'left' },
                { text: 'Ref no', sortable: false, align: 'left' },
                { text: 'Description', sortable: false, align: 'left' },
                { text: '', sortable: false, align: 'left' },
                // { text: '', sortable: false, align: 'left' },
            ],
            pagination: {'sortBy': 'glDate', 'descending': true},

            showViewGl: false,
        }
    },
    methods:{

        // Search general ledger by select month
        changeMonth(){
            let nextMonth = new Date(this.searchMonth)
            nextMonth.setMonth(nextMonth.getMonth()+1)
            nextMonth = nextMonth.toISOString().substr(0, 7)
            db.collection("generalLedger").where("glDate", ">", this.searchMonth).where("glDate", "<", nextMonth)
            .onSnapshot(querySnapshot=>{
                this.detail = []
                querySnapshot.forEach(doc=>{
                    this.detail.push(doc.data())
                })
            })
        },

        // Search general ledger by last year
        searchYear(){
            let year = new Date().toISOString().substr(0,4)
            db.collection("generalLedger").orderBy("glDate").startAt(year).endAt(year + "\uf8ff")
            .onSnapshot(querySnapshot=>{
                this.detail = []
                querySnapshot.forEach(doc=>{
                    this.detail.push(doc.data())
                })
                // console.log(this.detail)
            })
        },

        // Show general ledger detail
        viewGl(item){
            this.showViewGl = true
            console.log(item)
        }
    },
    mounted(){
        let nextMonth = new Date(this.searchMonth)
        nextMonth.setMonth(nextMonth.getMonth()+1)
        nextMonth = nextMonth.toISOString().substr(0, 7)
        db.collection("testGeneralLedger").where("glDate", ">", this.searchMonth).where("glDate", "<", nextMonth)
        // db.collection("generalLedger").where("glDate", ">", this.searchMonth).where("glDate", "<", nextMonth)
        .onSnapshot(querySnapshot=>{
            this.detail = []
            let checkArr = []
            let newDetail = []
            querySnapshot.forEach(doc=>{
                checkArr.push(doc.data())
                newDetail.push(doc.data())
            })

            let newArr = []
            checkArr.forEach(rec=>{
                let accDetail = []
                newDetail.forEach(obj=>{
                    if(obj.glNo == rec.glNo && obj.accId == rec.accId){
                        accDetail.push({accId: obj.accId, accName: obj.accName, debit: obj.debit, credit: obj.credit, remark: obj.remark})
                    }
                })
                newArr.push({glDate: rec.glDate, glNo: rec.glNo, refNo: rec.refNo, desc: rec.desc, accDetail: accDetail})
            })
            let map = new Map()
            for (let item of newArr) {
                if(!map.has(item.glNo)){
                    map.set(item.glNo, true)   // set any value to Map
                    this.detail.push({glDate: item.glDate, glNo: item.glNo, refNo: item.refNo, desc: item.desc, accDetail: item.accDetail})
                }
            }
            // console.log(this.detail)
        })
    }
}
</script>
